import API from "shared/services/Api";
import {
  IAnamneseData,
  IAnamnesePatient,
  IAnamnesePatientResponse,
  IAnamneseResponse,
} from "shared/types/Anamnese";

export const postAnamnese = async (
  data: IAnamneseData
): Promise<IAnamneseResponse> => API.post(`oc/anamnesis`, data);

export const getAnamnesePatient = async (
  data: IAnamnesePatient
): Promise<IAnamnesePatientResponse> =>
  API.get(`oc/anamnesis/patient?id=${data.userId}&idPac=${data.idPac}`);
